export const ECompanyOnboardingSection = {
  COMPANY_ONBOARDING: "company_onboarding",
} as const;

export type TCompanyOnboardingSection =
  (typeof ECompanyOnboardingSection)[keyof typeof ECompanyOnboardingSection];
